/**
 * The way back to CSRD's own screen for a table.
 *
 * A figure's history is read in CSRD, on the collection screen of the entity,
 * reporting and disclosure it came from. All three are on the table's link (its `ref` names the disclosure), so
 * the address is built from them and from where CSRD's screens are (`/csrd/web`).
 */

import { csrdWeb } from '@/api/csrd'
import type { CsrdLink } from '@/domain/section'

/** The collection screen of a linked table, or null where CSRD's address is not known. */
export function collectionUrl(link: CsrdLink, base: string): string | null {
  const root = base.trim().replace(/\/+$/, '')
  if (!root || !link.reportingCode || !link.entityCode || !link.ref) return null

  const query = new URLSearchParams({
    CodeReporting: link.reportingCode,
    CodeEntity: link.entityCode,
    // Its requirement (`R0-101`), which CSRD's screen names it by; not its code (`501060-101`).
    RoleType: link.ref,
  })
  return `${root}/collection?${query.toString()}`
}

let known: Promise<string> | null = null

/** Where CSRD's screens are, asked once. Empty when it is not said or cannot be read. */
export function csrdWebUrl(): Promise<string> {
  known ??= csrdWeb()
    .then((found) => found.url)
    .catch(() => {
      // Not worth remembering a failure: the next look asks again.
      known = null
      return ''
    })
  return known
}
